import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

const screen = SCREEN.FINANCIAL_ANALYSIS

export const getCorpCashBreakdownThunk = createAsyncThunk(
  'financialAnalysis/Corp/GET_CASH_BREAKDOWN',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getCashBreakdown(data)
    if (response.success) {
      const getValues = () => mapAllVNDValue(response.data)
      dispatch(calculateDefaultUnit({ screen, getValues }))
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadCorpCashBreakdown = createAsyncThunk(
  'financialAnalysis/Corp/DOWNLOAD_CASH_BREAKDOWN',
  async (data) => {
    const response = await FinancialAnalysisService.downloadCashBreakdown(data)
    handleExport(response.data, response.filename)
  },
)
